import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { ClienteCentralCompraFormControlTextComponent } from './cliente-central-compra-form-control-text.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteCentralCompraFormControlTextComponent
    ],
    exports: [
        ClienteCentralCompraFormControlTextComponent
    ]
})
export class ClienteCentralCompraFormControlTextModule { }
